import React from 'react';
import styles from './LogoutPopup.module.scss';
import { Popover } from 'antd';
import { LogoutPopupPropsEnums } from 'enums/LogoutPopupEnums';
import { ReactComponent as Logout } from 'assets/icons/logout.svg';
import { ReactComponent as Key } from 'assets/icons/key.svg';
import AccountsIcon from 'assets/icons/accounts_def.svg';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import { User } from 'models/User/User.model';
import { hasAdminAccess } from 'shared/utils/roleUtils';
interface LogoutPopupProps {
  children: React.ReactNode;
  logout: () => void;
}
const LogoutPopup: React.FC<LogoutPopupProps> = ({
  children,
  logout,
}: LogoutPopupProps) => {
  const navigate = useNavigate();
  const user = localStorage.getItem('userDetails');
  let parsedUser: User | null = null;
  if (user) {
    parsedUser = JSON.parse(user);
  }
  const handleResetPasswordNavigation = () => {
    if (parsedUser?.email) {
      navigate(AppRoutes.SET_NEW_PASS, { state: parsedUser.email });
    }
  };

  const canAccessAccounts = hasAdminAccess(parsedUser?.role);

  const handleAccountsNavigation = () => {
    navigate(`${AppRoutes.ACCOUNTS}/${AppRoutes.USER_DETAILS}`);
  };

  const content = (
    <div className={styles.contentContainer}>
      <div className={styles.userInfoContainer}>
        <div className={styles.userInfoRow}>
          <span className={styles.userInfoLabel}>Username:</span>
          <span className={styles.userInfoValue}>
            {parsedUser?.name || parsedUser?.email || 'N/A'}
          </span>
        </div>
        <div className={styles.userInfoRow}>
          <span className={styles.userInfoLabel}>User Role:</span>
          <span className={styles.userInfoValue}>
            {parsedUser?.role || 'N/A'}
          </span>
        </div>
      </div>
      {canAccessAccounts && (
        <div
          onClick={handleAccountsNavigation}
          className={styles.logoutContainer}>
          <img
            src={AccountsIcon}
            alt=""
            className={styles.accountsMenuIcon}
          />
          <h3>{LogoutPopupPropsEnums.ACCOUNTS}</h3>
        </div>
      )}
      <div
        onClick={handleResetPasswordNavigation}
        className={styles.logoutContainer}>
        <Key className={styles.logoutButton} />
        <h3>{LogoutPopupPropsEnums.CHANGE_PASSWORD}</h3>
      </div>
      <div onClick={logout} className={styles.logoutContainer}>
        <Logout className={styles.logoutButton} />
        <h3>{LogoutPopupPropsEnums.LOGOUT}</h3>
      </div>
    </div>
  );
  return (
    <Popover
      overlayClassName="profilePopup"
      placement={LogoutPopupPropsEnums.RIGHT}
      title={LogoutPopupPropsEnums.EMPTY_STRING}
      content={content}
      trigger={LogoutPopupPropsEnums.CLICK_TRIGGER}>
      {children}
    </Popover>
  );
};

export default LogoutPopup;
